import "./certificates.css"
import React, { useCallback, useEffect, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleChevronLeft, faCircleChevronRight, faCircleXmark } from "@fortawesome/free-solid-svg-icons"
import logoCertificates from "../../imagens/logos/logoCertificates.png"

function ImagesCertificates({ galleryImages }) {
    const [slideNumber, setSlideNumber] = useState(0)
    const [openModal, setOpenModel] = useState(false)


    // open Modal
    const handleOpenModal = (index) => {
        setSlideNumber(index)
        setOpenModel(true)
    }
    // close Modal
    const handleCloseModal = () => {
        setOpenModel(false)
    }
    // previous image
    const prevSlide = useCallback(() => {
        slideNumber === 0
            ? setSlideNumber(galleryImages.length - 1)
            : setSlideNumber(slideNumber - 1)
    }, [slideNumber, galleryImages.length])
    // next image
    const nextSlide = useCallback(() => {
        slideNumber + 1 === galleryImages.length
            ? setSlideNumber(0)
            : setSlideNumber(slideNumber + 1)
    }, [slideNumber, galleryImages.length])

    useEffect(() => {
        const handleKeyDown = (event) => {
            switch (event.key) {
                case 'Escape' :
                    handleCloseModal()
                    break
                case 'ArrowLeft':
                    prevSlide()
                    break;
                case 'ArrowRight':
                    nextSlide()
                    break;
                default:
                    break;
            }
        };

        if (openModal) {
            window.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [openModal, nextSlide, prevSlide]);

    return (
        <div>

            {openModal &&
                <div className="certificatesSliderWrap">
                    <FontAwesomeIcon icon={faCircleXmark} className="certificatesBtnClose" onClick={handleCloseModal} />
                    <FontAwesomeIcon icon={faCircleChevronLeft} className="certificatesBtnPrev" onClick={prevSlide} />
                    <FontAwesomeIcon icon={faCircleChevronRight} className="certificatesBtnNext" onClick={nextSlide} />
                    <img className="certificatesfullScreenImage" src={galleryImages[slideNumber].img} alt="Logo Certificates"></img>

                </div>
            }
            <img className="text-start ms-2 img-custom-size img-fluid" src={logoCertificates} alt="logoCapabilities" />
            <div className="container-fluid d-flex justify-content-evenly  ">
                {
                    galleryImages && galleryImages.map((image, index) => {
                        return (
                            <div
                                className="single col-sm-4 col-md-4 col-lg-2 mb-2 align-items-center align-self-center justify-content-center"
                                key={index}
                                onClick={() => handleOpenModal(index)}
                            >
                                <img src={image.img} alt="certificatesGalleryimages" />
                            </div>
                        )
                    })
                }

            </div>
        </div>
    )
}

export default ImagesCertificates